import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import initialize from "./actions";
import store from "./store";
import App from "./components/App";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/uk';

store.dispatch(initialize()).then(() => {
  const container = document.getElementById("root");
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="uk">
          <App />
        </LocalizationProvider>
      </Provider>
    </React.StrictMode>,
  );
});
